/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.CountryFilter = (function() {

    /**
     * Namespace CountryFilter.
     * @exports CountryFilter
     * @namespace
     */
    var CountryFilter = {};

    CountryFilter.CountryFilterModel = (function() {

        /**
         * Properties of a CountryFilterModel.
         * @memberof CountryFilter
         * @interface ICountryFilterModel
         * @property {string|null} [query] CountryFilterModel query
         * @property {number|null} [active] CountryFilterModel active
         * @property {string|null} [sortColumn] CountryFilterModel sortColumn
         * @property {string|null} [sortOrder] CountryFilterModel sortOrder
         * @property {number|null} [pageIndex] CountryFilterModel pageIndex
         * @property {number|null} [pageSize] CountryFilterModel pageSize
         */

        /**
         * Constructs a new CountryFilterModel.
         * @memberof CountryFilter
         * @classdesc Represents a CountryFilterModel.
         * @implements ICountryFilterModel
         * @constructor
         * @param {CountryFilter.ICountryFilterModel=} [p] Properties to set
         */
        function CountryFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CountryFilterModel query.
         * @member {string|null|undefined} query
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.query = null;

        /**
         * CountryFilterModel active.
         * @member {number|null|undefined} active
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.active = null;

        /**
         * CountryFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.sortColumn = null;

        /**
         * CountryFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.sortOrder = null;

        /**
         * CountryFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.pageIndex = null;

        /**
         * CountryFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        CountryFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * CountryFilterModel _query.
         * @member {"query"|undefined} _query
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CountryFilterModel _active.
         * @member {"active"|undefined} _active
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_active", {
            get: $util.oneOfGetter($oneOfFields = ["active"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CountryFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CountryFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CountryFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CountryFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof CountryFilter.CountryFilterModel
         * @instance
         */
        Object.defineProperty(CountryFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified CountryFilterModel message. Does not implicitly {@link CountryFilter.CountryFilterModel.verify|verify} messages.
         * @function encode
         * @memberof CountryFilter.CountryFilterModel
         * @static
         * @param {CountryFilter.ICountryFilterModel} m CountryFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(10).string(m.query);
            if (m.active != null && Object.hasOwnProperty.call(m, "active"))
                w.uint32(16).int32(m.active);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified CountryFilterModel message, length delimited. Does not implicitly {@link CountryFilter.CountryFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof CountryFilter.CountryFilterModel
         * @static
         * @param {CountryFilter.ICountryFilterModel} message CountryFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CountryFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CountryFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof CountryFilter.CountryFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {CountryFilter.CountryFilterModel} CountryFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.CountryFilter.CountryFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.query = r.string();
                    break;
                case 2:
                    m.active = r.int32();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a CountryFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof CountryFilter.CountryFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {CountryFilter.CountryFilterModel} CountryFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CountryFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return CountryFilterModel;
    })();

    return CountryFilter;
})();

module.exports = $root;
